<template>
  <section class="table-events-category">
    <div class="table-events-category__title">{{ title }}</div>
    <div class="table-events-category__row-titles">
      <div class="table-events-category__row-titles__col-range">Rango de tiempo (segundos)</div>
      <div class="table-events-category__row-titles__col-teams">
        <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.home_team + '.png'" />
      </div>
      <div class="table-events-category__row-titles__col-teams">
        <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.visiting_team + '.png'" />
      </div>
      <div class="table-events-category__row-titles__col-totals">TOTAL</div>
      <div class="table-events-category__row-titles__col-prom">Promedio por partido actual torneo</div>
    </div>
    <template v-for="(val, index) in info">
      <div :key="index" class="table-events-category__row-values">
        <div class="table-events-category__row-values__col-range">{{ val.range }}</div>
        <div class="table-events-category__row-values__col-teams">{{ val.home_team_total }}</div>
        <div class="table-events-category__row-values__col-teams">{{ val.visiting_team_total }}</div>
        <div class="table-events-category__row-values__col-totals">{{ val.total }}</div>
        <div class="table-events-category__row-values__col-prom">{{ val.average_per_game }}</div>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'TableEventsCategory',
  components: {},
  props: {
    title: {
      type: Boolean,
      required: true,
    },
    info: {
      type: Object,
      required: true,
    },
    teams: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.color-gray {
  background-color: #f6f8fb !important;
}
.table-events-category {
  width: 100%;
  height: auto;
  border: solid 1px #b4c9dd;
  &__title {
    width: 100%;
    height: 44px;
    background-color: #132739;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-family: 'Avenir-Bold';
    font-style: normal;
    line-height: 44px;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
  }
  &__row-titles {
    width: 100%;
    height: 86px;
    background-color: #52a0fc;
    display: inline-flex;
    justify-content: left;
    align-content: center;
    align-items: center;
    overflow: hidden;
    border-top: solid 1px #b4c9dd;
    border-bottom: solid 1px #b4c9dd;
    &__col-range {
      width: 18.9%;
      height: 86px;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: normal;
      font-family: 'Avenir-Demi';
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      text-align: center;
      border-right: solid 1px #b4c9dd;
      color: #fff;
      &__medium {
        font-family: 'Avenir-Medium';
      }
      @media screen and (max-width: 1030px) {
        font-size: 12px;
      }
      @media screen and (max-width: 930px) {
        font-size: 11px;
      }
      @media screen and (max-width: 830px) {
        font-size: 14px;
      }
      @media screen and (max-width: 480px) {
        font-size: 12px;
      }
      @media screen and (max-width: 500px) {
        width: 24.22%;
      }
      @media screen and (max-width: 400px) {
        font-size: 10px;
      }
    }
    &__col-teams {
      width: 18.9%;
      height: 86px;
      background: white;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-right: solid 1px #b4c9dd;
      img {
        width: 56px;
        @media screen and (max-width: 500px) {
          width: 40px;
        }
        @media screen and (max-width: 400px) {
          width: 32px;
        }
      }
      @media screen and (max-width: 500px) {
        width: 11.9%;
      }
    }
    &__col-totals {
      width: 18.9%;
      height: 86px;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-right: solid 1px #b4c9dd;
      font-size: 14px;
      font-family: 'Avenir-Bold';
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      @media screen and (max-width: 1030px) {
        font-size: 12px;
      }
      @media screen and (max-width: 930px) {
        font-size: 11px;
      }
      @media screen and (max-width: 830px) {
        font-size: 14px;
      }
      @media screen and (max-width: 480px) {
        font-size: 12px;
      }
      @media screen and (max-width: 500px) {
        width: 24.22%;
      }
      @media screen and (max-width: 400px) {
        font-size: 10px;
      }
    }
    &__col-prom {
      width: 24.78%;
      height: 86px;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: normal;
      font-family: 'Avenir-Demi';
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      @media screen and (max-width: 1030px) {
        font-size: 12px;
      }
      @media screen and (max-width: 930px) {
        font-size: 11px;
      }
      @media screen and (max-width: 830px) {
        font-size: 14px;
      }
      @media screen and (max-width: 480px) {
        font-size: 12px;
      }
      @media screen and (max-width: 500px) {
        width: 29.55%;
      }
      @media screen and (max-width: 400px) {
        font-size: 10px;
      }
    }
  }

  &__row-values {
    width: 100%;
    height: 53px;
    background-color: #fff;
    display: inline-flex;
    justify-content: left;
    align-content: center;
    align-items: center;
    overflow: hidden;
    @media screen and (max-width: 500px) {
      font-size: 14px;
      height: 43px;
    }
    &__col-range {
      width: 18.9%;
      height: 56px;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-right: solid 1px #b4c9dd;
      @media screen and (max-width: 500px) {
        width: 24.22%;
        height: 43px;
      }
    }
    &__col-teams {
      width: 18.9%;
      height: 56px;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-right: solid 1px #b4c9dd;
      @media screen and (max-width: 500px) {
        width: 11.9%;
        height: 43px;
      }
    }
    &__col-totals {
      width: 18.9%;
      height: 56px;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-right: solid 1px #b4c9dd;
      @media screen and (max-width: 500px) {
        width: 24.22%;
        height: 43px;
      }
    }
    &__col-prom {
      width: 24.78%;
      height: 56px;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;

      @media screen and (max-width: 500px) {
        width: 29.55%;
        height: 43px;
      }
    }
  }
  &__row-values:nth-child(even) {
    background-color: #f6f8fb !important;
  }
}
</style>
